import React, { Component, Fragment } from 'react';
import DisplayViewing from './display_viewing';
import ViewingSelector from './viewing_selector';
import ViewingEventSelector from './viewing_event_selector';
import ViewingCancelledConfirmation from './viewing_cancelled_confirmation';
import I18n from '~/utils/translations';
import HttpRequestor from '~/components/http_requestor';

import _every from 'lodash/every';
import _isEmpty from 'lodash/isEmpty';

import VirtualTourImage from '~/images/image-virtual.png';

export default class HomeActionsManager extends Component {
  constructor(props) {
    super(props);

    const defaultSelected = this.defaultSelectedDayTime();

    const showViewingEvents =
      props.viewingEvents &&
      props.viewingEvents.length > 0 &&
      defaultSelected.selectedDay == null &&
      defaultSelected.selectedTime == null;

    this.state = {
      defaultSelectedDayTime: defaultSelected,
      showBookingSection: props.showBookingSection || false,
      showAvailableViewings: !showViewingEvents,
      showAvailableViewingEvents: showViewingEvents,
      hasPotentialViewing: props.hasPotentialViewing,
      hasConfirmedViewing: props.hasConfirmedViewing,
      canBookViewing: props.canBookViewing,
      showBookingButton: props.canBookViewing,
      animateBookViewingSection: false,
      viewingCancelError: false,
    };
  }

  componentDidMount() {
    const hasDefaultSelectedDayTime = !_every(this.state.defaultSelectedDayTime, _isEmpty);
    if ((this.state.canBookViewing && window.location.hash == '#book-viewing') || hasDefaultSelectedDayTime) {
      this.setState(
        {
          showBookingSection: true,
          showBookingButton: false,
          canBookViewing: true,
        },
        () => {
          this.scrollToViewingContainer(1000);
        }
      );
    }

    if (window.location.hash == '#booked-viewing') {
      this.safeScrollTo(this.bookedViewing, 1000, 'center');
    }
  }

  scrollToViewingContainer = (delay = 0) => {
    const block = this.props.viewingEvents && this.props.viewingEvents.length > 0 ? 'start' : 'center';
    if (!this.props.scrollIntoView) {
      return;
    }
    this.safeScrollTo(this.viewingContainer, delay, block);
  };

  safeScrollTo = (node, delay = 1000, block = 'start', behavior = 'smooth') => {
    if (!node) return;

    setTimeout(() => {
      try {
        node.scrollIntoView({
          behavior,
          block,
        });
      } catch (error) {
        if (e instanceof TypeError) {
          // Older firefox doesn't support center for the block option
          // and will throw an error.
          node.scrollIntoView({
            behavior,
            block: 'start',
          });
        } else {
          throw error;
        }
      }
    }, delay);
  };

  defaultSelectedDayTime = () => {
    let result = {
      selectedDay: null,
      selectedTime: null,
      selectedSlot: null,
    };

    if (sessionStorage.getItem('selectedTime')) {
      const { day, time, slot } = JSON.parse(sessionStorage.getItem('selectedTime'));
      sessionStorage.removeItem('selectedTime');

      if (day && time) {
        result.selectedDay = day;
        result.selectedTime = time;
      }

      if (slot && this.props.viewingEvents) {
        const selectedSlot = this.props.viewingEvents.find((viewing_slot) => viewing_slot.id == slot);
        result.selectedSlot = selectedSlot;
      }
    }

    return result;
  };

  toggleVirtualBookingSectionVisibility = (e) => {
    e.preventDefault();

    this.setState({
      showVirtualBookingSection: true,
      showBookingSection: false,
    });
  };

  handleVirtualTourGoBack = (e) => {
    e.stopPropagation();
    e.preventDefault();

    this.setState({ showVirtualBookingSection: false });

    zE('webWidget', 'close');
  };

  handleVirtualTourBooking = (e) => {
    e.preventDefault();

    track_event('book-virtual-tour', 'book-virtual-tour', 'click');

    zE('webWidget', 'prefill', {
      name: {
        value: this.props.firstname,
        readOnly: this.props.firstname ? true : false,
      },
      email: {
        value: this.props.email,
        readOnly: this.props.email ? true : false,
      },
    });

    zE('webWidget:on', 'open', () => {
      //  textArea is not immediately available to React, need to wait for browser re-paint
      setTimeout(this.updateChatboxWithVirtualTourDate, 1400);
    });
    zE('webWidget', 'toggle');
  };

  updateChatboxWithVirtualTourDate = () => {
    const textAreaInWebWidget = document.getElementById('webWidget').contentWindow.document.querySelector('textarea');
    if (textAreaInWebWidget) {
      textAreaInWebWidget.focus();
      textAreaInWebWidget.value = I18n.t('viewings.virtual_tour.book_request_text', {
        property: this.props.property.privatisedAddress,
        property_id: this.props.property.id,
      });
    }
  };

  toggleBookingSectionVisibility = (e) => {
    e.preventDefault();

    this.setState(
      {
        viewingCancelled: false, // hides the viewing cancelled confirmation component
        showBookingSection: true,
        animateBookViewingSection: true,
      },
      () => {
        track_event('home-viewing-flow', 'toggle-form', 'show');
        const block = this.state.showAvailableViewingEvents ? 'start' : 'center';
        this.viewingContainer.scrollIntoView({
          behavior: 'smooth',
          block: block,
        });
      }
    );
  };

  viewingSectionAnimationCompleted = () => {
    this.setState({
      animateBookViewingSection: false,
    });
  };

  toggleViewingOptions = (e) => {
    e.preventDefault();
    const { showAvailableViewings, showAvailableViewingEvents } = this.state;

    this.setState({
      showAvailableViewings: !showAvailableViewings,
      showAvailableViewingEvents: !showAvailableViewingEvents,
    });
  };

  handleViewingBooked = (bookedViewing, id) => {
    this.setState(
      {
        bookedViewing,
        bookedViewingId: id,
        hasPotentialViewing: true,
        showAvailableViewings: false,
        showAvailableViewingEvents: false,
      },
      () => {
        this.viewingContainer.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });

        // the scrollIntoView above relies on the canBookViewing being visible, so
        // only set to hidden after we have scrolled :)
        this.setState({ canBookViewing: false });
        this.setState({ showBookingButton: false });
      }
    );
  };

  handleViewingCancelled = async (cancellationReason) => {
    track_event('cancel-my-viewing', 'cancel-my-viewing', 'click');

    try {
      const requestor = new HttpRequestor();
      const response = await requestor.call(this.cancelViewingUrl, 'PATCH', {
        cancellation_reason: cancellationReason,
      });

      this.setState({
        hasPotentialViewing: false,
        hasConfirmedViewing: false,
        showBookingSection: false,
        showBookingButton: true,
        viewingCancelled: true,
        canBookViewing: true,
        showAvailableViewings: true,
        viewingCancelledPreviousTime: this.previousViewingTime,
        viewingCancelError: false,
      });
    } catch (err) {
      this.setState({
        viewingCancelError: true,
      });
    }
  };

  renderViewingCancelledConfirmation = () => {
    if (this.state.viewingCancelled) {
      return (
        <ViewingCancelledConfirmation
          viewingCancelledPreviousTime={this.state.viewingCancelledPreviousTime}
          property={this.props.property}
        />
      );
    }
  };

  renderActionButtons() {
    if (this.state.showVirtualBookingSection) return null;

    const { canContinuePaperwork, canVisitLiving } = this.props;
    const buttons = [];

    if (this.props.canBookVirtualViewing) {
      buttons.push(
        <a
          href="#viewings"
          className="home-actions__virtual-viewing home-actions__button home-actions__button--primary"
          onClick={this.toggleVirtualBookingSectionVisibility}
          key="book-virtual-viewing"
        >
          {I18n.t('viewings.virtual_tour.book_action')}
        </a>
      );
    }

    if (this.state.canBookViewing && this.state.showBookingButton) {
      buttons.push(
        <a
          href="#viewings"
          className="home-actions__viewing home-actions__button home-actions__button--primary"
          onClick={this.toggleBookingSectionVisibility}
          key="book-viewing"
        >
          {this.viewingButtonText}
        </a>
      );
    }

    if (canContinuePaperwork && this.props.applicationUrl) {
      buttons.push(
        <a
          href={this.props.applicationUrl}
          className="home-actions__button home-actions__button--primary-outline"
          key="continue-paperwork"
        >
          {I18n.t('viewings.complete_application_action')}
        </a>
      );
    }

    if (canVisitLiving) {
      buttons.push(
        <a
          href={this.props.doorbellHost}
          className="home-actions__button home-actions__button--primary-outline"
          key="visit-living"
        >
          {I18n.t('viewings.actioned_application_action')}
        </a>
      );
    }

    return (
      <Fragment>
        <div className="home-actions__buttons">{buttons}</div>
      </Fragment>
    );
  }

  renderViewingOptions() {
    if (!this.state.showBookingSection) return null;

    if (this.state.showAvailableViewings) {
      const selectorOptions = {
        userHasSession: this.props.userHasSession,
        showOtherOptions: this.props.viewingEvents.length > 0 ? this.toggleViewingOptions : null,
        property: this.props.property,
        listing: this.props.listing,
        handleViewingBooked: this.handleViewingBooked,
        doorbellHost: this.props.doorbellHost,
        frontdoorHost: this.props.frontdoorHost,
        selectedDay: this.state.defaultSelectedDayTime.selectedDay,
        selectedTime: this.state.defaultSelectedDayTime.selectedTime,
        animated: this.state.animateBookViewingSection,
        onAnimationCompleted: this.viewingSectionAnimationCompleted,
        latestCustomPreQualificationAnswers: this.props.latestCustomPreQualificationAnswers,
        preQualificationQuestions: this.props.preQualificationQuestions,
        email: this.props.email,
        isFullUser: this.props.isFullUser,
        preQualPassed: this.props.preQualPassed,
        viewingsPaused: this.props.viewingsPaused,
      };

      return <ViewingSelector {...selectorOptions} />;
    }

    if (this.state.showAvailableViewingEvents) {
      return (
        <ViewingEventSelector
          userHasSession={this.props.userHasSession}
          showOtherOptions={this.toggleViewingOptions}
          property={this.props.property}
          listing={this.props.listing}
          viewingEvents={this.props.viewingEvents}
          handleViewingBooked={this.handleViewingBooked}
          doorbellHost={this.props.doorbellHost}
          selectedSlot={this.state.defaultSelectedDayTime.selectedSlot}
          latestCustomPreQualificationAnswers={this.props.latestCustomPreQualificationAnswers}
          preQualificationQuestions={this.props.preQualificationQuestions}
          email={this.props.email}
          isFullUser={this.props.isFullUser}
          preQualPassed={this.props.preQualPassed}
          viewingsPaused={this.props.viewingsPaused}
        />
      );
    }
  }

  renderVirtualTour() {
    if (!this.state.showVirtualBookingSection) return null;

    return (
      <div class="virtual-tour">
        <div className="virtual-tour__image" style={{ backgroundImage: `url(${VirtualTourImage})` }}></div>
        <div className="virtual-tour__content">
          <h2 className="virtual-tour__content-heading">{I18n.t('viewings.virtual_tour.what')}</h2>
          <p>{I18n.t('viewings.virtual_tour.explainer')}</p>
          <p>{I18n.t('viewings.virtual_tour.explainer_sub')}</p>
          <div className="virtual-tour__buttons">
            <div className="virtual-tour__action">
              <button
                onClick={this.handleVirtualTourBooking}
                className="home-actions__button home-actions__button--primary"
              >
                {I18n.t('viewings.virtual_tour.book_action')}
              </button>
            </div>
            <button onClick={this.handleVirtualTourGoBack} className="home-actions__go-back home-actions__link">
              {I18n.t('viewings.virtual_tour.go_back')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderUpcomingViewing() {
    let startTime;
    let endTime;
    let dateString;
    if (this.state.bookedViewing) {
      dateString = this.state.bookedViewing.timeLabel;
      const viewing = this.state.bookedViewing;

      if (viewing.startTime) {
        startTime = viewing.startTime;
        endTime = viewing.endTime;
      } else {
        startTime = viewing.datetime;
      }
    } else {
      dateString = this.props.propertyInterest.enquiryDateAndTime;
      startTime = this.props.propertyInterest.activityTime;
      const viewingEvent = this.props.propertyInterest.nextViewingEvent;
      if (viewingEvent) {
        endTime = viewingEvent.attributes.end_time;
      }
    }

    return (
      <div ref={(ref) => (this.bookedViewing = ref)}>
        <DisplayViewing
          title={this.viewingCreatedCopy}
          fullAddress={this.props.property.fullAddress}
          locale={this.props.property.locale}
          headline={this.props.property.headline}
          datetime={dateString}
          viewingStart={startTime}
          viewingEnd={endTime}
          handleViewingCancelled={this.handleViewingCancelled}
          viewingCancelError={this.state.viewingCancelError}
          allowViewingCancel={this.props.allowViewingCancel}
          property={this.props.property}
          hasConfirmedViewing={this.props.hasConfirmedViewing}
        />
      </div>
    );
  }

  render() {
    if (!this.props.enableMarketingViewings) {
      return null;
    }

    return (
      <Fragment>
        {this.renderViewingCancelledConfirmation()}
        {this.renderActionButtons()}
        {this.renderVirtualTour()}
        {this.state.canBookViewing && (
          <div ref={(ref) => (this.viewingContainer = ref)} id="viewings">
            {this.renderViewingOptions()}
          </div>
        )}
        {this.state.hasPotentialViewing && this.renderUpcomingViewing()}
        {this.state.error && this.renderError()}
      </Fragment>
    );
  }

  get cancelViewingUrl() {
    return `/homes/${this.props.property.id}/viewings/${this.viewingId}/cancel?locale=london`;
  }

  get viewingId() {
    return this.state.bookedViewing ? this.state.bookedViewingId : this.props.propertyInterest.viewingId;
  }

  get previousViewingTime() {
    return this.state.bookedViewing
      ? this.state.bookedViewing.timeLabel
      : this.props.propertyInterest.enquiryDateAndTime;
  }

  get viewingCreatedCopy() {
    return this.props.property.requestViewingEnabled && !this.state.hasConfirmedViewing
      ? I18n.t('viewings.viewing_is_requested')
      : I18n.t('viewings.viewing_is_booked');
  }

  get viewingButtonText() {
    return this.props.property.requestViewingEnabled
      ? I18n.t('viewings.request_viewing_action')
      : I18n.t('viewings.book_viewing_action');
  }
}
